import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { ToastrService } from 'ngx-toastr';
import { noop, of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { Observer } from 'rxjs/internal/types';
import { map, switchMap, tap } from 'rxjs/operators';
import { OverpackListingSearchEnum, PackageStatusEnum } from 'src/app/enums';
import { BaseSearch } from 'src/app/models/base-search';
import { Overpacks } from 'src/app/models/overpacks';
import { Packages } from 'src/app/models/packages';
import { ResponseDTO } from 'src/app/models/response-dto';
import { Overpackfilteroption } from 'src/app/searchFilters/overpackfilteroption';
import { PackageFilterOption } from 'src/app/searchFilters/package-filter-option';
import { CountryService } from 'src/app/services/country.service';
import { FranchiseeService } from 'src/app/services/franchisee.service';
import { OverpackServices } from 'src/app/services/overpack.service';
import { PackageServices } from 'src/app/services/package.service';
import { PagerService } from 'src/app/services/pager-service';

@Component({
  selector: 'app-assign-overpack',
  templateUrl: './assign-overpack.component.html',
  styleUrls: ['./assign-overpack.component.css']
})
export class AssignOverpackComponent implements OnInit {

  isLoadingResults = false;
  ddlCountries: any[] = [];
  franchiseeList: any[] = [];
  ddlCountriesAZPH: any[] = [];
  countryId;
  baseSearch: BaseSearch<Packages>;
  page: any;
  pager: any = {};
  dataSource: MatTableDataSource<Packages> = new MatTableDataSource<Packages>();
  data: Packages[] = [];
  totalItems: any = 0;
  currentIndex: number = 1;
  shippingMethod: number = 1;
  currentIndex1: number = 1;
  startIndex: number = 1;
  pageSize: number = 20;
  pageSize1: number = 20;
  endIndex: number = this.pageSize;
  sortby: string = '';
  order: string = '';
  packageCode: string;
  trackingId: string;
  customerName: string;
  customerId: number;
  status: string = PackageStatusEnum.AvailableToShip.toString();
  overpackedStatus: string = PackageStatusEnum.Overpacked.toString();
  pageCount: number = 0;
  pageCount1: number = 0;
  isScroll: boolean = false;
  list: any[] = [];
  overpackedList: any[] = [];
  overPacks: Overpacks[] = [];
  packageCountryId: number;
  isSearchLoading: boolean = false;
  isSearchLoadingOverpack: boolean = false;
  selectedPackage: any;
  selectedOverpack: any;

  displayReset: boolean = false;
  //package scan
  suggestions$: Observable<any[]>;
  observer;
  search: string = "";
  packageFilter: PackageFilterOption = new PackageFilterOption();
  typeaheadLoading: boolean = false;
  searchOverpack: string = "";
  suggestions1$: Observable<any[]>;
  inBinLocation: number = 0;
  disableAssign: boolean = true;
  packageLoading: boolean = false;
  overpackedPackageLoading: boolean = false;

  @ViewChild('overpackFocus', {
    static: false
  }) overpackInput: ElementRef;


  @ViewChild('packageFocus', {
    static: false
  }) packageInput: ElementRef;
  constructor(private contryService: CountryService, private toastr: ToastrService, private pagerService: PagerService, private packageService: PackageServices, private overpackApi: OverpackServices, private packageApi: PackageServices, private franchiseeService : FranchiseeService) { }

  ngOnInit(): void {
    this.sortby = 'modifiedDate';
    this.order = 'desc';
    //this.getCountryListDDL();
    this.getFRCountryListDDLForAll();
    this.getBinLocationCount();
    // this.getBinLocationCount();
    //this.getPackageCollections(this.currentIndex, this.pageSize, this.packageCode, this.trackingId, this.customerId, this.status, this.order, this.sortby, this.countryId);
    //this.getOverpackedPackageCollections(this.currentIndex1, this.pageSize1, this.packageCode, this.trackingId, this.customerId, this.overpackedStatus, this.order, this.sortby, this.countryId);
    ////// this.bindAutoComplete();
    /////this.bindAutoCompleteOverpack();
  }

  getCountryListDDL() {
    this.isLoadingResults = true;
    this.contryService.getCountryList().subscribe(data => {
      if (data.statusCode == 200) {
        this.isLoadingResults = false;
        this.ddlCountries = data.result;
        this.ddlCountries.sort((a, b) => a.countryName > b.countryName ? 1 : -1);
        this.ddlCountries.forEach(country => {
          if (country.countryName == "Azerbaijan") {
            this.countryId = country.countryId;
            this.onCountryChange(this.countryId);
          }
        })
      }
    }, err => {
      this.toastr.error("Failed To Get Country", "Coutries");
      this.isLoadingResults = false;
    });
  }

  getFRCountryListDDLForAll() {
    this.isLoadingResults = true;
    this.franchiseeService.getAllFranchises().subscribe(data => {
      if (data.statusCode == 200) {
        this.isLoadingResults = false;
        this.franchiseeList = data.result;
        if(this.franchiseeList != null && this.franchiseeList.length > 0){
          this.ddlCountries = this.franchiseeList.map(x=>x.country);
          this.ddlCountries.sort((a, b) => a.countryName > b.countryName ? 1 : -1);
        }
        if(this.ddlCountries != null && this.ddlCountries.length > 0){
          this.countryId = this.ddlCountries[0].countryId;
          this.onCountryChange(this.countryId);
        }
      }
    }, err => {
      this.toastr.error("Failed To Get Country", "Coutries");
      this.isLoadingResults = false;
    });
  }

  onCountryChange(countryId) {
    this.currentIndex = 1;
    this.currentIndex1 = 1;
    this.list = [];
    this.overpackedList = [];
    this.totalItems = 0;
    this.inBinLocation = 0;
    this.shippingMethod = 1;
    this.getPackageCollections(this.currentIndex, this.pageSize, this.packageCode, this.trackingId, this.customerId, this.status, this.order, this.sortby, this.countryId,this.shippingMethod);
    this.getOverpackedPackageCollections(this.currentIndex1, this.pageSize1, this.packageCode, this.trackingId, this.customerId, this.overpackedStatus, this.order, this.sortby, this.countryId,this.shippingMethod);
    this.getBinLocationCount();
  }

  isMarkAsAwailableToShipByFranchise(countryId : number){
    if(countryId == 14){
      return true;
    }
    return false;
  }

  getPackageCollections(currentPage: number, pageSize: number, packageCode: string = '', trackingNumber: string = '', customerId: number, status: string = '', order: string, sortby: string = '', countryId: number,shippingMethod: number=1) {
    //this.isLoadingResults = true;
    this.packageLoading = true;
    this.packageService.getPackages(currentPage, pageSize, order, sortby, packageCode, trackingNumber, customerId, status, null, this.isMarkAsAwailableToShipByFranchise(this.countryId), this.countryId,this.shippingMethod).subscribe(data => {

      this.baseSearch = data["result"];

      if (this.baseSearch) {
        this.data = this.baseSearch.values;


        if (this.currentIndex == 1) {
          this.pageCount = data.result.pageCount;
          this.list = this.data;
          // this.isLoadingResults = false;
          this.packageLoading = false;
        }
        if (this.currentIndex > 1) {
          this.list.push(...this.data);
          //this.isLoadingResults = false;
          this.packageLoading = false;
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.pager = this.pagerService.getPager(this.baseSearch == null ? 0 : this.baseSearch.rowCount, this.baseSearch == null ? 0 : this.baseSearch.currentPage, this.baseSearch == null ? this.pageSize : this.baseSearch.pageSize);
        this.totalItems = this.pager.totalItems;
        this.page = this.currentIndex;
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
      }
      return true;
      //Stop Loading screen
      // this.isLoadingResults = false;
      this.packageLoading = false;
    }, err => {
      console.log(err);
      this.isLoadingResults = false;
      return true;
    });
  }

  getRedirectURL(statusInt: number, packageId: number, hasPickTicket: boolean, binLocation: string) {
    return this.packageService.getRedirectionURL(packageId, statusInt, hasPickTicket, binLocation);
  }

  onScrollDown() {
    if (this.currentIndex != this.pageCount) {
      this.currentIndex += 1;
      this.packageLoading = true;
      this.getPackageCollections(this.currentIndex, this.pageSize, this.packageCode, this.trackingId, this.customerId, this.status, this.order, this.sortby, this.countryId,this.shippingMethod);
    } else {
      this.isScroll = true;
    }
  }
  /*
    bindAutoComplete() {
      this.suggestions$ = new Observable((observer: Observer<string>) => {
        this.observer = observer;
        this.search = this.search.toString().trim();
        observer.next(this.search);
      })
        .pipe(
          switchMap((query: string = '') => {
            if (query) {
              this.packageFilter.searchKey = query;
              this.packageFilter.isFromGlobalSearch = false;
              this.packageFilter.status = PackageStatusEnum.AvailableToShip.toString();
              this.packageFilter.markAsAvailableToShipByFr = true;
              if(this.countryId != null || this.countryId !=""){
                this.packageFilter.CountryId = this.countryId;
              }
              this.isSearchLoading = true;
              return query.length < 2 ? [] : this.packageApi.getSearchPackages(1, 10, 'asc', 'packageCode', this.packageFilter)
                .pipe(
                  map((data: ResponseDTO) => {
                    this.isSearchLoading = false;
                    if (data && data["result"])
                      return data["result"]["values"];
                    else return [];
                  }),
                  tap(() => noop, err => {
                    alert(err && err.message || 'package not found.');
                  })
                );
            }
            return of([]);
          })
        );
    }
  
    changeTypeaheadLoading(e: boolean): void {
      this.disableAssign = true;
      this.selectedOverpack = null;
      this.selectedPackage = null;
      this.searchOverpack = null;
      this.typeaheadLoading = e;
    }
  
    typeaheadPackageOnSelect(e: TypeaheadMatch): void {
  
      if (e.item.packageId > 0) {
        this.packageApi.getPackageById(e.item.packageId).subscribe(res => {
          if (res["statusCode"] == 200) {
            this.selectedPackage = res["result"];
            if(this.selectedPackage.statusInt == PackageStatusEnum.AvailableToShip){
              this.disableAssign = false;
            }
          }
        })
      }
    }
    */
  //overpack scan
  /*
  bindAutoCompleteOverpack() {
    this.suggestions1$ = new Observable((observer: Observer<string>) => {
      this.observer = observer;
      this.searchOverpack = this.searchOverpack.toString().trim();
      observer.next(this.searchOverpack);
    })
      .pipe(
        switchMap((query: string = '') => {
          if (query) {
            this.isSearchLoadingOverpack = true;
            return query.length < 2 ? [] : this.overpackApi.getOverpacksByFranchiseId(1, 20, 'asc', 'Shipment.ShipmentDate', this.selectedPackage?.countryId, OverpackListingSearchEnum[OverpackListingSearchEnum.InProcess], query)
              .pipe(
                map((data: ResponseDTO) => {
                  this.isSearchLoadingOverpack = false;
                  if (data && data["result"])
                    return data["result"]["values"];
                  else return [];
                }),
                tap(() => noop, err => {
                  alert(err && err.message || 'overpack not found.');
                })
              );
          }
          return of([]);
        })
      );
  }

  changeTypeaheadLoading1(e: boolean): void {
    this.selectedOverpack = null;
    this.typeaheadLoading = e;
  }

  typeaheadOverpackOnSelect(e: TypeaheadMatch): void {
    if (e.item.overpackId > 0) {
      this.overpackApi.getOverpackById(e.item.overpackId).subscribe(res => {
        if (res["statusCode"] == 200) {
          this.selectedOverpack = res["result"];
        }
      })
    }
  }
*/
  onAssignOverpack() {
    if (this.selectedPackage == null) {
      this.toastr.error("Please scan valid package");
    } else if (this.selectedOverpack == null) {
      this.toastr.error("Please scan valid overpack");
    } else {
      this.isLoadingResults = true;
      this.packageApi.AddPackageToOverPack(this.selectedPackage.packageId, this.selectedOverpack.overpackId).subscribe(res => {
        if (res["statusCode"] == 200) {
          this.packageInput.nativeElement.focus();
          this.search = "";
          this.searchOverpack = "";
          this.selectedOverpack = null;
          this.selectedPackage = null;
          this.toastr.success(res["message"]);          
          this.currentIndex = 1;
          this.currentIndex1 = 1;
          this.shippingMethod = 1;
          
          this.getPackageCollections(this.currentIndex, this.pageSize, this.packageCode, this.trackingId, this.customerId, this.status, this.order, this.sortby, this.countryId,this.shippingMethod);
          this.getOverpackedPackageCollections(this.currentIndex1, this.pageSize1, this.packageCode, this.trackingId, this.customerId, this.overpackedStatus, this.order, this.sortby, this.countryId,this.shippingMethod);
          // this.getBinLocationCount();
          this.isLoadingResults = false;
        }
      }, err => {
        console.error(err);
        this.isLoadingResults = false;
      })
    }
  }

  //get Overpacked Packages

  getOverpackedPackageCollections(currentPage: number, pageSize: number, packageCode: string = '', trackingNumber: string = '', customerId: number, status: string = '', order: string, sortby: string = '', countryId: number,shippingMethod: number=1) {
    ////this.isLoadingResults = true;
    this.overpackedPackageLoading = true;
    this.packageService.getPackages(currentPage, pageSize, order, sortby, packageCode, trackingNumber, customerId, status, null, this.isMarkAsAwailableToShipByFranchise(this.countryId), countryId,this.shippingMethod).subscribe(data => {

      this.baseSearch = data["result"];
      if (this.baseSearch) {
        this.data = this.baseSearch.values;

        if (this.currentIndex1 == 1) {
          this.pageCount1 = data.result.pageCount;
          this.overpackedList = this.data;
          ///this.isLoadingResults = false;
          this.overpackedPackageLoading = false;
        }

        if (this.currentIndex1 > 1) {
          this.overpackedList.push(...this.data);
          ///this.isLoadingResults = false;
          this.overpackedPackageLoading = false;
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.pager = this.pagerService.getPager(this.baseSearch == null ? 0 : this.baseSearch.rowCount, this.baseSearch == null ? 0 : this.baseSearch.currentPage, this.baseSearch == null ? this.pageSize : this.baseSearch.pageSize);
        //this.totalItems = this.pager.totalItems;
        this.page = this.currentIndex;
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
      }

      //Stop Loading screen
      // this.isLoadingResults = false;
    }, err => {
      console.log(err);
      ///this.isLoadingResults = false;
      this.overpackedPackageLoading = false;
    });
  }
  onOverpackedScrollDown() {
    if (this.currentIndex1 != this.pageCount1) {
      this.currentIndex1 += 1;
      this.getOverpackedPackageCollections(this.currentIndex1, this.pageSize1, this.packageCode, this.trackingId, this.customerId, this.overpackedStatus, this.order, this.sortby, this.countryId,this.shippingMethod);
    } else {
      this.isScroll = true;
    }
  }

  getBinLocationCount() {
    // this.isLoadingResults = true;
    this.packageApi.getPackagesForBinLocationCount(PackageStatusEnum.AvailableToShip.toString(), this.isMarkAsAwailableToShipByFranchise(this.countryId), this.countryId).subscribe(res => {
      if (res["statusCode"] == 200) {
        this.inBinLocation = res.result;
        // this.isLoadingResults = false;
      }

    })
  }

  

  focusOutScanPackage() {
    let filter: PackageFilterOption = new PackageFilterOption();
    filter.searchKey = this.search;
    filter.CountryId = this.countryId;
    if (this.search.length >= 13) {
      this.packageApi.getOnlyPackageByCode(filter).subscribe(res => {
        if (res["statusCode"] == 200) {
          this.selectedPackage = res["result"];
          if (this.selectedPackage.statusInt == PackageStatusEnum.AvailableToShip) {
            this.disableAssign = false;
            this.overpackInput.nativeElement.focus();

          }
          else {
            this.toastr.error('Package cannot be overpacked. Please check package detail.')
            this.disableAssign = true;
            this.search = '';
          }
        }
      }, err => {
        console.log(err);
        this.toastr.error(err)
      })
    }
  }



  focusOutScanOverpack() {
    if (this.searchOverpack.length >= 13) {
      let filter: Overpackfilteroption = new Overpackfilteroption();
      filter.countryId = this.countryId;
      filter.status = OverpackListingSearchEnum.InProcess.toString();
      filter.overpackCode = this.searchOverpack;
      if (!this.disableAssign) {
        this.overpackApi.getOverpacks(0, 1, 'asc', 'OverpackCode', filter).subscribe(res => {
          if (res["statusCode"] == 200) {
            if (res["result"].values.length > 0) {
              this.selectedOverpack = res["result"].values[0];
              this.onAssignOverpack();

            }
            else {
              this.toastr.error('Overpack not found.');
            }
          }
        }, err => {
          this.searchOverpack = '';
          this.toastr.error(err);
        })
      }
      else {
        this.toastr.error('Please select package.');
        this.searchOverpack = '';
      }
    }
  }
}
